import { NoPic } from "../../../exports/Images";
import { CrossCircleIcon } from "../../../images/icons/icons";
import { genericFunction } from "../../common-data/Conversions";

export const returnAccurate = (isAvailable, value, row, setModValues) => {
  const isDocument = value
    ?.toLowerCase()
    .match(
      /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|rtf|odt|ods|odp|heic|heif|pages|numbers|keynote)$/
    );

  const className = isDocument ? "icon" : isAvailable ? "image" : "";

  const getProcessedImageUrl = (url) => {
    if (!url) return NoPic;

    let processedUrl = genericFunction(url);

    if (!processedUrl || processedUrl === url) {
      processedUrl = url;
    }

    const separator = processedUrl.includes("?") ? "&" : "?";
    const cacheBuster = `t=${Date.now()}`;

    return `${processedUrl}${separator}${cacheBuster}`;
  };

  return (
    <p className={`info-name ${className}`}>
      {!isAvailable ? (
        <CrossCircleIcon />
      ) : isDocument ? (
        <a className="" rel="noreferrer" target="_blank" href={value}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-box-arrow-up-right text-primary"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
            />
            <path
              fillRule="evenodd"
              d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
            />
          </svg>
        </a>
      ) : (
        <img
          src={getProcessedImageUrl(value)}
          alt={row?.name || "NA"}
          className="image"
          onClick={() => {
            setModValues((prevs) => ({
              ...prevs,
              isModOpen: true,
              cardName: "staff_photo",
              image: getProcessedImageUrl(value),
              rowData: row,
            }));
          }}
        />
      )}
    </p>
  );
};
